module.exports = __webpack_public_path__ + "img/组 7473.e9a699c7.png";